module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Gemini Virus")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-522-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 5:22 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#march-2000.-sometime-close-to-midnight."
    }
  }, [_vm._v("March, 2000. Sometime close to midnight.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-528-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 5:28 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-543-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 5:43 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-554-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 5:54 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-558-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 5:58 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-559-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 5:59 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-603-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 6:03 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-606-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 6:06 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-608-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 6:08 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-14th-2010-616-pm"
    }
  }, [_vm._v("Wednesday, April 14th, 2010, 6:16 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#summer-2005.-biomesh-laboratories"
    }
  }, [_vm._v("Summer, 2005. Biomesh Laboratories,")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-15th-2010.-756-am."
    }
  }, [_vm._v("Thursday, April 15th, 2010. 7:56 AM.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-15th-2010.-937-am."
    }
  }, [_vm._v("Thursday, April 15th, 2010. 9:37 AM.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-15th-2010.-1132-am"
    }
  }, [_vm._v("Thursday, April 15th, 2010. 11:32 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-15th-2010.-1158-am"
    }
  }, [_vm._v("Thursday, April 15th, 2010. 11:58 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-15th-2010-1231-pm"
    }
  }, [_vm._v("Thursday, April 15th, 2010, 12:31 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-15th-2010-142-pm"
    }
  }, [_vm._v("Thursday, April 15"), _c('sup', [_vm._v("th")]), _vm._v(", 2010, 1:42 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#autumn-2005.-biomesh-laboratories."
    }
  }, [_vm._v("Autumn, 2005. Biomesh Laboratories.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#winter-2005.-biomesh-laboratories."
    }
  }, [_vm._v("Winter, 2005. Biomesh Laboratories.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-1016-am"
    }
  }, [_vm._v("Friday, April 16th, 2010, 10:16 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-447-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 4:47 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#january-2006.-biomesh-laboratories."
    }
  }, [_vm._v("January 2006. Biomesh Laboratories.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-451-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 4:51 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-500-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 5:00 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-507-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 5:07 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-511-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 5:11 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-532-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 5:32 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-537-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 5:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-16th-2010-549-pm"
    }
  }, [_vm._v("Friday, April 16th, 2010, 5:49 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-april-17th-2010.-1200-pm"
    }
  }, [_vm._v("Saturday, April 17th, 2010. 12:00 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-20th-2010-914-pm"
    }
  }, [_vm._v("Tuesday, April 20th, 2010, 9:14 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-april-24th-2010-1017-am"
    }
  }, [_vm._v("Saturday, April 24th, 2010, 10:17 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-april-24th-2010-1051-am"
    }
  }, [_vm._v("Saturday, April 24th, 2010, 10:51 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-april-24th-2010-1027-pm"
    }
  }, [_vm._v("Saturday, April 24th, 2010, 10:27 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-february-14th-2000-723-pm"
    }
  }, [_vm._v("Monday, February 14"), _c('sup', [_vm._v("th")]), _vm._v(", 2000, 7:23 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-april-24th-2010-1103-pm"
    }
  }, [_vm._v("Saturday, April 24"), _c('sup', [_vm._v("th")]), _vm._v(", 2010, 11:03 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-april-24th-2010-1137-pm"
    }
  }, [_vm._v("Saturday, April 24th, 2010, 11:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-april-25th-2010-1232-am"
    }
  }, [_vm._v("Sunday, April 25th, 2010, 12:32 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-1142-am"
    }
  }, [_vm._v("Monday, April 26th, 2010, 11:42 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-1214-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 12:14 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-119-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 1:19 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-136-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 1:36 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-337-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 3:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-429-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 4:29 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-504-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 5:04 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-509-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 5:09 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-637-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 6:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-april-26th-2010-843-pm"
    }
  }, [_vm._v("Monday, April 26th, 2010, 8:43 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-27th-2010-916-am"
    }
  }, [_vm._v("Tuesday, April 27th, 2010, 9:16 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#july-1999-0330-local-time"
    }
  }, [_vm._v("July, 1999, 03:30, Local Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#july-1999-0430-local-time"
    }
  }, [_vm._v("July, 1999, 04:30, Local Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-27th-2010-1003-am"
    }
  }, [_vm._v("Tuesday, April 27th, 2010, 10:03 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-27th-2010-1217-pm"
    }
  }, [_vm._v("Tuesday, April 27th, 2010, 12:17 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-27th-2010-243-pm"
    }
  }, [_vm._v("Tuesday, April 27th, 2010, 2:43 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-27th-2010-608-pm"
    }
  }, [_vm._v("Tuesday, April 27th, 2010, 6:08 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#tuesday-april-27th-2010-712-pm"
    }
  }, [_vm._v("Tuesday, April 27th, 2010, 7:12 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-914-am"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 9:14 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-may-9th-1994-307-pm"
    }
  }, [_vm._v("Monday, May 9th, 1994, 3:07 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-920-am"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 9:20 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-1037-am"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 10:37 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-1221-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 12:21 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-237-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 2:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-319-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 3:19 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-347-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 3:47 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-351-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 3:51 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-416-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 4:16 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-421-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 4:21 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#august-1984.-the-rose-family-farm."
    }
  }, [_vm._v("August, 1984. The Rose family farm.")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-442-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 4:42 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-506-pm"
    }
  }, [_vm._v("Wednesday, April 28th, 2010, 5:06 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#wednesday-april-28th-2010-712-pm"
    }
  }, [_vm._v("Wednesday, April 28"), _c('sup', [_vm._v("th")]), _vm._v(", 2010, 7:12 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-857-am"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 8:57 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-1113-am"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 11:13 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-1234-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 12:34 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-116-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 1:16 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-237-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 2:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-243-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 2:43 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-319-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 3:19 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-341-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 3:41 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-436-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 4:36 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-442-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 4:42 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-457-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 4:57 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-512-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 5:12 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-531-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 5:31 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-602-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:02 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-623-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:23 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-631-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:31 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-634-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:34 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-636-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:36 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-640-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:40 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-642-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:42 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-647-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:47 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-652-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:52 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-654-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:54 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-656-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 6:56 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-702-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 7:02 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-706-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 7:06 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#thursday-april-29th-2010-711-pm"
    }
  }, [_vm._v("Thursday, April 29th, 2010, 7:11 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-842-am"
    }
  }, [_vm._v("Friday, April 30th, 2010, 8:42 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-836-am"
    }
  }, [_vm._v("Friday, April 30th, 2010, 8:36 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-947-am"
    }
  }, [_vm._v("Friday, April 30th, 2010, 9:47 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-1148-am"
    }
  }, [_vm._v("Friday, April 30th, 2010, 11:48 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-119-pm"
    }
  }, [_vm._v("Friday, April 30th, 2010, 1:19 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-142-pm"
    }
  }, [_vm._v("Friday, April 30th, 2010, 1:42 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#friday-april-30th-2010-237-pm"
    }
  }, [_vm._v("Friday, April 30th, 2010, 2:37 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-may-1st-2010-907-am"
    }
  }, [_vm._v("Saturday, May 1st, 2010, 9:07 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-may-1st-2010-932-am"
    }
  }, [_vm._v("Saturday, May 1st, 2010, 9:32 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-may-1st-2010-1119-am"
    }
  }, [_vm._v("Saturday, May 1st, 2010, 11:19 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-may-1st-2010-1219-pm"
    }
  }, [_vm._v("Saturday, May 1st, 2010, 12:19 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-may-1st-2010-341-pm"
    }
  }, [_vm._v("Saturday, May 1st, 2010, 3:41 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#saturday-may-1st-2010-341-pm-1"
    }
  }, [_vm._v("Saturday, May 1"), _c('sup', [_vm._v("st")]), _vm._v(", 2010, 3:41 PM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-may-2nd-2010-912-am"
    }
  }, [_vm._v("Sunday, May 2nd, 2010, 9:12 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#sunday-may-2nd-2010-1114-am"
    }
  }, [_vm._v("Sunday, May 2nd, 2010, 11:14 AM")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Section0001#monday-august-11th-1947-1352"
    }
  }, [_vm._v("Monday, August 11th, 1947, 13:52")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0